import UserCardSkeleton from "./UserCardSkeleton";

const DashboardSkeleton = ({ count = 3 }) => (
  <div className="user-cards">
    {Array.from({ length: count }, (_, index) => (
      <UserCardSkeleton key={index} />
    ))}
  </div>
);

export default DashboardSkeleton;
